var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSlash = function SvgSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 37 36",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.583 18C.583 8.11 8.61.083 18.5.083 28.39.083 36.417 8.11 36.417 18c0 9.89-8.027 17.917-17.917 17.917C8.61 35.917.583 27.89.583 18ZM18.5 2.584C9.99 2.584 3.083 9.49 3.083 18c0 8.51 6.907 15.417 15.417 15.417S33.917 26.51 33.917 18 27.01 2.584 18.5 2.584Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.884 5.45a1.25 1.25 0 0 1 0 1.767L7.55 30.551a1.25 1.25 0 1 1-1.768-1.768L29.116 5.45a1.25 1.25 0 0 1 1.768 0Z",
    fill: "currentColor"
  })));
};
export default SvgSlash;